import Link from "next/link";
import LocaleSwitch from "./LocaleSwitch";
import Navigation from "../Navigation";
import drmLogo from "!!raw-loader!../../assets/img/drm-logo.svg";

export default function Header({ data }) {
  return (
    <div className="header">
      <div className="my-6 w-full cursor-pointer">
        <Link href={{ pathname: "/" }}>
          <div dangerouslySetInnerHTML={{ __html: drmLogo }} className="w-40" />
        </Link>
      </div>
      <div className="flex justify-between w-full my-6 text-2xl">
        <div>
          <Navigation
            data={data}
            parent="home"
            itemClass="mr-6 xl:mr-16 hover:text-black "
          />
        </div>
        <LocaleSwitch />
      </div>
    </div>
  );
}
